export enum FeatureFlagName {
  AUDIO_STREAMING = 'audio-streaming',
  AUDIO_POSTS = 'audio-posts',
  COMMUNITY_SUBMISSIONS = 'community-submissions',
  COMMUNITY_OFFICIAL_AUTHORS = 'community-official-authors',
  COMMUNITY_NOTIFICATION_EMAILS = 'community-notification-emails',
}
